import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store.js";

import moment from "moment";
moment.locale("en");
Vue.prototype.$moment = moment;

import constPlugin from "./util/constant.js";
Vue.use(constPlugin);

import funcPlugin from "./util/functions.js";
Vue.use(funcPlugin);

import user from "./store/user.js";
Vue.prototype.$user = user;

import collection from "./store/collection.js";
Vue.prototype.$collection = collection;

import money from "v-money";
Vue.use(money, {
  decimal: ".",
  thousands: ",",
  prefix: "",
  suffix: " USD",
  precision: 0,
  masked: false,
});

import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);

import Axios from "axios";
Vue.prototype.$http = Axios.create({
  // baseURL: "https://localhost:5001",
  baseURL: "https://spp-api.scancom.net",
  timeout: 120000,
});

Vue.prototype.$http.interceptors.request.use(
  (config) => {
    const userStr = Vue.prototype.$func.getCookie("user-scancom");
    if (userStr) {
      let user = JSON.parse(decodeURI(userStr));
      config.headers["Authorization"] = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import VueSweetalert2 from "vue-sweetalert2";
// // If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
  mounted() {
    if (this.$user.getters.authUser) {
      this.$collection.dispatch("getUserCollection");
    }
  },
});
